module.exports = __webpack_public_path__ + "static/media/kilmadao.8d59e2e1.jpg";